import { node } from "~/util/dom";
import { ILocation } from "./interfaces";
import { IBrowserLocation } from "./util/providers/geoLocation";

let elem: HTMLDivElement = null;
let listElem: HTMLUListElement = null;

function build() {
	const container = node("div", { className: "location-debug" });
	const list = node("ul", { className: "ld-list" });

	container.append(list);
	elem = container;
	listElem = list;
	document.body.append(container);
}

export function setLocationDebug(enabled: boolean) {
	if (enabled) {
		build();
	} else if (elem) {
		elem.remove();
	}
}

export function locationDebugLog(line: string) {
	if (listElem) {
		const item = node("li");

		item.innerHTML = line;
		listElem.append(item);
	}
}

export function locationDebugLocation(location: ILocation, browserLocation?: IBrowserLocation) {
	if (listElem) {
		const item = node("li");

		if (location) {
			let dateFreshness = "";

			switch (location.dateFreshness) {
				case "fresh":
					dateFreshness = "cerstva";
					break;

				case "historic":
					dateFreshness = "historicka";
					break;

				case "old":
					dateFreshness = "zastarala";
					break;

				case "not-set":
					dateFreshness = "zadna cerstvost";
					break;

				default:
			}

			item.textContent = `lon: ${location.lon.toFixed(3)}, lat: ${location.lat.toFixed(3)}, acc: ${location.precision}, pl: ${location.precisionLevel}, ${dateFreshness},`
				+ ` ${location.isPrecise ? "presna" : "nepresna"}, ${location.isTrustworthy ? "duveryhodna" : "neduveryhodna"}, ${location.type}`;
		} else if (browserLocation) {
			item.textContent = `lon: ${browserLocation.coords.longitude.toFixed(3)}, lat: ${browserLocation.coords.latitude.toFixed(3)}, acc: ${browserLocation.coords.accuracy}, browser`;
		}

		listElem.append(item);
	}
}
